import { useEffect } from 'react';
import { useTranslate } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { useBranding } from './contexts/BrandingContext';

const PageTitle = () => {
    const translate = useTranslate();
    const location = useLocation();
    const { branding, companyName } = useBranding();

    useEffect(() => {
        // Use setTimeout to ensure we override React Admin's title after it sets it
        const timer = setTimeout(() => {
            const path = location.pathname;
            const appName = branding.appTitle || companyName || 'Online Academy';
            let title = appName;

            // Parse the current route to determine the page title
            if (path === '/' || path === '') {
                title = `Dashboard - ${appName}`;
            } else if (path === '/login') {
                title = `Login - ${appName}`;
            } else if (path === '/profile') {
                title = translate('custom.profile.title') + ` - ${appName}`;
            } else if (path === '/change-password') {
                title = translate('custom.changePassword') + ` - ${appName}`;
            } else if (path.startsWith('/companies')) {
                const resourceTitle = translate('resources.companies.name', { smart_count: 2 });
                if (path.includes('/create')) {
                    title = `${translate('ra.page.create', { name: resourceTitle })} - ${appName}`;
                } else if (path.match(/\/companies\/\d+$/)) {
                    title = `${resourceTitle} - ${appName}`;
                } else {
                    title = `${resourceTitle} - ${appName}`;
                }
            } else if (path.startsWith('/users')) {
                const resourceTitle = translate('resources.users.name', { smart_count: 2 });
                if (path.includes('/create')) {
                    title = `${translate('ra.page.create', { name: resourceTitle })} - ${appName}`;
                } else if (path.match(/\/users\/\d+$/)) {
                    title = `${resourceTitle} - ${appName}`;
                } else {
                    title = `${resourceTitle} - ${appName}`;
                }
            } else if (path.startsWith('/roles')) {
                const resourceTitle = translate('resources.roles.name', { smart_count: 2 });
                title = `${resourceTitle} - ${appName}`;
            } else if (path.startsWith('/permissions')) {
                const resourceTitle = translate('resources.permissions.name', { smart_count: 2 });
                title = `${resourceTitle} - ${appName}`;
            } else if (path.startsWith('/products')) {
                const resourceTitle = translate('resources.products.name', { smart_count: 2 });
                title = `${resourceTitle} - ${appName}`;
            } else if (path.startsWith('/licenses')) {
                const resourceTitle = translate('resources.licenses.name', { smart_count: 2 });
                title = `${resourceTitle} - ${appName}`;
            }

            document.title = title;
        }, 0);

        return () => clearTimeout(timer);
    }, [location.pathname, translate, branding.appTitle, companyName]);

    return null;
};

export default PageTitle;
